document.addEventListener('DOMContentLoaded', function() {
    initLeasingQuickView();
  });
  
  function initLeasingQuickView() {
    document.querySelectorAll('.leasing-quickview-button').forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        const productHandle = this.getAttribute('data-product-handle');
        openLeasingQuickView(productHandle);
      });
    });
  }
  
  function openLeasingQuickView(productHandle) {
    fetch(`/products/${productHandle}.js`)
      .then(response => response.json())
      .then(product => {
        // Create modal
        const modal = document.createElement('div');
        modal.classList.add('leasing-quickview-modal');
        modal.innerHTML = `
          <div class="leasing-quickview-content">
            <button class="leasing-quickview-close">&times;</button>
            <div class="leasing-product-quick-view">
              <div class="leasing-product-quick-view__info">
                <div class="leasing-product-quick-view__description">
                  ${product.description}
                </div>
              </div>
            </div>
          </div>
        `;
        
        // Add modal to page
        document.body.appendChild(modal);
        
        // Close modal on click outside or on close button
        modal.addEventListener('click', function(e) {
          if (e.target === modal || e.target.classList.contains('leasing-quickview-close')) {
            modal.remove();
          }
        });
      });
  }
  
  document.addEventListener('shopify:section:load', initLeasingQuickView);
